import { createSlice } from '@reduxjs/toolkit'
import { JoinState } from './types'

export const initialJoinState: JoinState = {
  forms: {
    contactInfo: null,
    locationAndFleet: null,
  },
  stationTypes: [],
  currentStep: 1,
}

export const joinSlice = createSlice({
  name: 'join',
  initialState: initialJoinState,
  reducers: {
    setCurrentStep(state, action) {
      state.currentStep = action.payload
    },
    setContactFormValues(state, action) {
      state.forms.contactInfo = action.payload
    },
    setLocationAndFleetFormValues(state, action) {
      state.forms.locationAndFleet = action.payload
    },
    resetFormValues(state) {
      state.forms = initialJoinState.forms
    },
    setStationTypes(state, action) {
      state.stationTypes = action.payload
    },
  },
})

export const joinReducer = joinSlice.reducer
export const {
  setCurrentStep,
  setContactFormValues,
  setLocationAndFleetFormValues,
  resetFormValues,
  setStationTypes,
} = joinSlice.actions
